// Environment configuration, selected at build time from `REACT_APP_STAGE`:
//   (unset, e.g. `yarn start`)            -> local
//   REACT_APP_STAGE=dev react-scripts ... -> dev
//   REACT_APP_STAGE=prod react-scripts ...-> prod
//
// These values (API + app domains, S3 bucket) are static and change very rarely, so they live in
// source rather than being generated from CloudFormation outputs on every backend deploy. Deploying
// the backend no longer touches the frontend; the frontend only redeploys when it changes.

type Stage = 'dev' | 'prod'

export interface EnvConfig {
	stage: Stage
	apiBaseUrl: string
	s3BaseUrl: string
	appUrl: string
}

const local: EnvConfig = {
	stage: 'dev',
	// Local frontend talks to the serverless-offline backend (`yarn offline`). REST routes are served
	// under the stage prefix, so the base path is /dev.
	apiBaseUrl: 'http://localhost:5005/dev',
	s3BaseUrl: 'doc-dev.finlert.com',
	// SSO redirect target for local dev. Must exactly match a Cognito app-client callback URL — the dev
	// pool registers `http://localhost:4999/`, so run/open the app at localhost (not billy.localhost),
	// otherwise Cognito bounces you to the billy-dev URL after login.
	appUrl: 'http://localhost:4999/',
}

const dev: EnvConfig = {
	stage: 'dev',
	apiBaseUrl: 'https://api-oversight-dev.finlert.com',
	s3BaseUrl: 'doc-dev.finlert.com',
	appUrl: 'https://billy-dev.finlert.com/',
}

const prod: EnvConfig = {
	stage: 'prod',
	apiBaseUrl: 'https://api-oversight.finlert.com',
	s3BaseUrl: 'doc.finlert.com',
	appUrl: 'https://billy.finlert.com/',
}

const configs: Record<string, EnvConfig> = { dev, prod }

export const env: EnvConfig = configs[process.env.REACT_APP_STAGE ?? ''] ?? local
